import { computed } from 'vue'

import { useNavItemsStore } from '@/stores/navigationItems'

export const fetchLowerNavigationMenu = async () => {
  const navItemsStore = useNavItemsStore()

  try {
    await navItemsStore.fetchButterLowerNavData()
  } catch (error) {
    console.error('Error during fetching lower nav data:', error)
  } finally {
    navItemsStore.updateIsLoadedLower(true)
  }
}

export const useNavigationLowerData = async () => {
  const navItemsStore = useNavItemsStore()

  if (!navItemsStore.getIsLoadedLower) {
    await fetchLowerNavigationMenu()
  }
  return navItemsStore.getNavLower
}

export const getLoadedStateLower = () => {
  const navItemsStore = useNavItemsStore()
  return computed(() => navItemsStore.getIsLoadedLower)
}
